import { ChatMessageContact as MessageContact } from '@src/types';
import env from '@src/utils/env';
import React from 'react';
import { useIntl } from 'react-intl';
import ChatMessageContactBtn from './ChatMessageContactBtnStyle';

export type ChatMessageContactDownloadProps = {
  contact: MessageContact;
};

const ChatMessageContactDownload: React.FC<ChatMessageContactDownloadProps> = ({
  contact,
}) => {
  const { formatMessage } = useIntl();

  const onClickDownloadBtn = () => {
    const downloadPath = `${env.WEB_SERVICE_CONTACTS_BASE_URI}/contacts/vcard`;
    fetch(downloadPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contact),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const tempUrl = window.URL.createObjectURL(blob);
        const tempLInk = document.createElement('a');
        tempLInk.style.display = 'none';
        tempLInk.href = tempUrl;
        tempLInk.download = `${contact.name.first_name
          .toLocaleLowerCase()
          .replace(/ /g, '-')}.vcf`;
        document.body.appendChild(tempLInk);
        tempLInk.click();
        window.URL.revokeObjectURL(tempUrl);
      });
  };
  return (
    <ChatMessageContactBtn type="button" onClick={onClickDownloadBtn}>
      {formatMessage({ id: 'Console.ContactMessage.Download' })}
    </ChatMessageContactBtn>
  );
};

export default ChatMessageContactDownload;
